/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-redeclare */
import createLinearScale from "./scales/linear.js";
import createLogScale from "./scales/log.js";
import createPowScale from "./scales/power.js";
import createSqrtScale from "./scales/squareRoot.js";
import createSymlogScale from "./scales/symlog.js";
import createTimeScale from "./scales/time.js";
import createUtcScale from "./scales/utc.js";
import createQuantileScale from "./scales/quantile.js";
import createQuantizeScale from "./scales/quantize.js";
import createThresholdScale from "./scales/threshold.js";
import createOrdinalScale from "./scales/ordinal.js";
import createPointScale from "./scales/point.js";
import createBandScale from "./scales/band.js";
import createRadialScale from "./scales/radial.js"; // Overload function for more strict typing, e.g.,
// If the config is a linear config then a ScaleLinear will be returned
// instead of a union type of all scales.
// Actual implementation

function createScale(config) {
  if (typeof config !== 'undefined' && 'type' in config) {
    switch (config.type) {
      case 'linear':
        return createLinearScale(config);
      case 'log':
        return createLogScale(config);
      case 'pow':
        return createPowScale(config);
      case 'sqrt':
        return createSqrtScale(config);
      case 'symlog':
        return createSymlogScale(config);
      case 'time':
        return createTimeScale(config);
      case 'utc':
        return createUtcScale(config);
      case 'quantile':
        return createQuantileScale(config);
      case 'quantize':
        return createQuantizeScale(config);
      case 'threshold':
        return createThresholdScale(config);
      case 'ordinal':
        return createOrdinalScale(config);
      case 'point':
        return createPointScale(config);
      case 'band':
        return createBandScale(config);
      case 'radial':
        return createRadialScale(config);
      default:
    }
  }

  // If type is not specified, fallback to linear scale
  return createLinearScale(config);
}
export default createScale;